<script>

    export let current_page
    export let total_pages
    export let navigate_prev
    export let navigate_next
    export let navigate_page
    export let per_page
    export let pagination_limit

    $: rangeHigh = current_page * per_page;
    $: rangeLow = rangeHigh - per_page;

    const pagechecker = () => {
        console.log("pagination thinks current page is", current_page)
    }
</script>


<div class="pagination">
    <button on:click={() => navigate_prev() } disabled={current_page == 1}>Previous</button>
    <ul class="table-nav">


    {#each [3,2,1] as i}
        {#if current_page - i > 0}
        <li><button on:click={() => navigate_page(current_page - i) } >{current_page - i}</li>
        {/if}
    {/each}
    <li><span>{current_page}</span></li>
    {#each Array(3) as _, i}
        {#if current_page + (i+1) <= total_pages}
        <li><button on:click={() => navigate_page(current_page + (i+1)) } >{current_page + (i+1)}</li>
        {/if}
    {/each}
    
    </ul>

    <button on:click={() => navigate_next() } disabled={current_page == total_pages}>Next</button>
</div>

<style>
     .pagination {
        display: none;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin: .4em 0 .8em;
        font-size: .86em;
    }
    :global(.pagination.active) {
        display: flex;
    }
    ul.table-nav {
        display: flex;
        list-style: none;
        padding: 0;
        margin: 0;
        position: relative;
        top: 2px;
    }

    ul.table-nav li span, ul.table-nav li button {
        
        font-family: 'canada-type-gibson', sans-serif;
        
    }

    ul.table-nav li span {
        position: relative;
        top: 6px;
        margin: 0 .5em;
        font-weight: 600;
    }
    button {
        background: #0070BA;
        color: #fff;
        border: none;
        padding: .5em;
        cursor: pointer;
        font-weight: 600;
        border-radius: 2px;
    }
    button:disabled {
        background: #78abce;
        color: #fff;
        cursor: default;
    }
    ul.table-nav li button {
        margin: 0 .2em;
    }
</style>